export const STORES_ID = Object.freeze({
	310: 310, // komplett.no
	312: 312, // komplett.se
	318: 318, // itegra.se
	321: 321, // komplett.dk
	324: 324, // komplettbedrift.no
	325: 325, // itegra.no
	344: 344, // komplettforetag.se
});

export const STORE_TYPE = Object.freeze({
	B2C: "b2c",
	B2B: "b2b",
});

export const isHiddenForStores = ({ stores, storeId }) => {
	return stores.includes(storeId);
};

export const isB2BStore = ({ storeId }) => {
	return ![STORES_ID["310"], STORES_ID["312"], STORES_ID["321"]].includes(
		parseInt(storeId, 10),
	);
};
